export const aiLoadingLottie = {
  nm: 'Flow 4',
  ddd: 0,
  h: 20,
  w: 20,
  meta: { g: 'LottieFiles Figma v61' },
  layers: [
    {
      ty: 0,
      nm: 'AI Loader - solid blue✅',
      sr: 1,
      st: 0,
      op: 145,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: true,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 0,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 54,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 72,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 126,
            },
            {
              o: { x: 0, y: 0 },
              i: { x: 1, y: 1 },
              s: [10, 10],
              t: 144,
            },
            { s: [10, 10], t: 198 },
          ],
        },
        s: {
          a: 1,
          k: [
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100, 100],
              t: 0,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100, 100],
              t: 54,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100, 100],
              t: 72,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100, 100],
              t: 126,
            },
            {
              o: { x: 0, y: 0 },
              i: { x: 1, y: 1 },
              s: [100, 100],
              t: 144,
            },
            { s: [100, 100], t: 198 },
          ],
        },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 0,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 54,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 72,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [10, 10],
              t: 126,
            },
            {
              o: { x: 0, y: 0 },
              i: { x: 1, y: 1 },
              s: [10, 10],
              t: 144,
            },
            { s: [10, 10], t: 198 },
          ],
        },
        r: {
          a: 1,
          k: [
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [0],
              t: 0,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [0],
              t: 54,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [0],
              t: 72,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [0],
              t: 126,
            },
            {
              o: { x: 0, y: 0 },
              i: { x: 1, y: 1 },
              s: [0],
              t: 144,
            },
            { s: [0], t: 198 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: {
          a: 1,
          k: [
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100],
              t: 0,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100],
              t: 54,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100],
              t: 72,
            },
            {
              o: { x: 0.33, y: 1 },
              i: { x: 0.68, y: 1 },
              s: [100],
              t: 126,
            },
            {
              o: { x: 0, y: 0 },
              i: { x: 1, y: 1 },
              s: [100],
              t: 144,
            },
            { s: [100], t: 198 },
          ],
        },
      },
      masksProperties: [
        {
          nm: '',
          inv: false,
          mode: 'a',
          x: { a: 0, k: 0 },
          o: { a: 0, k: 100 },
          pt: {
            a: 1,
            k: [
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20, 0],
                      [20, 20],
                      [0, 20],
                      [0, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20, 0],
                      [20, 20],
                      [0, 20],
                      [0, 0],
                    ],
                  },
                ],
                t: 54,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20, 0],
                      [20, 20],
                      [0, 20],
                      [0, 0],
                    ],
                  },
                ],
                t: 72,
              },
              {
                o: { x: 0.33, y: 1 },
                i: { x: 0.68, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20, 0],
                      [20, 20],
                      [0, 20],
                      [0, 0],
                    ],
                  },
                ],
                t: 126,
              },
              {
                o: { x: 0, y: 0 },
                i: { x: 1, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20, 0],
                      [20, 20],
                      [0, 20],
                      [0, 0],
                    ],
                  },
                ],
                t: 144,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20, 0],
                      [20, 20],
                      [0, 20],
                      [0, 0],
                    ],
                  },
                ],
                t: 198,
              },
            ],
          },
        },
      ],
      w: 20,
      h: 20,
      refId: '1',
      ind: 1,
    },
  ],
  v: '5.7.0',
  fr: 60,
  op: 144,
  ip: 0,
  assets: [
    {
      nm: '[Asset] AI Loader - solid blue✅',
      id: '1',
      layers: [
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 145,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [3.69, 3.69],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [3.69, 3.69],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [9.09, 9.09],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [9.09, 9.09],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [3.69, 3.69],
                  t: 144,
                },
                { s: [3.69, 3.69], t: 198 },
              ],
            },
            s: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [100, 100],
                  t: 144,
                },
                { s: [100, 100], t: 198 },
              ],
            },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [15.75, 3.63],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [15.75, 3.63],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10.97, 9.03],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10.97, 9.03],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [15.75, 3.63],
                  t: 144,
                },
                { s: [15.75, 3.63], t: 198 },
              ],
            },
            r: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [0],
                  t: 144,
                },
                { s: [0], t: 198 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [100],
                  t: 144,
                },
                { s: [100], t: 198 },
              ],
            },
          },
          ef: [],
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.04, -0.15],
                          [0, 0],
                          [-1.32, -0.33],
                          [0, 0],
                          [0, -0.15],
                          [0.15, -0.04],
                          [0, 0],
                          [0.33, -1.32],
                          [0, 0],
                          [0.15, 0],
                          [0.04, 0.15],
                          [0, 0],
                          [1.32, 0.33],
                          [0, 0],
                          [0, 0.15],
                          [-0.15, 0.04],
                          [0, 0],
                          [-0.33, 1.32],
                          [0, 0],
                          [-0.15, 0],
                        ],
                        o: [
                          [0.15, 0],
                          [0, 0],
                          [0.33, 1.32],
                          [0, 0],
                          [0.15, 0.04],
                          [0, 0.15],
                          [0, 0],
                          [-1.32, 0.33],
                          [0, 0],
                          [-0.04, 0.15],
                          [-0.15, 0],
                          [0, 0],
                          [-0.33, -1.32],
                          [0, 0],
                          [-0.15, -0.04],
                          [0, -0.15],
                          [0, 0],
                          [1.32, -0.33],
                          [0, 0],
                          [0.04, -0.15],
                          [0, 0],
                        ],
                        v: [
                          [3.69, 0],
                          [4.02, 0.25],
                          [4.1, 0.59],
                          [6.79, 3.28],
                          [7.13, 3.37],
                          [7.38, 3.69],
                          [7.13, 4.02],
                          [6.79, 4.1],
                          [4.1, 6.79],
                          [4.02, 7.13],
                          [3.69, 7.38],
                          [3.37, 7.13],
                          [3.28, 6.79],
                          [0.59, 4.1],
                          [0.25, 4.02],
                          [0, 3.69],
                          [0.25, 3.37],
                          [0.59, 3.28],
                          [3.28, 0.59],
                          [3.37, 0.25],
                          [3.69, 0],
                        ],
                      },
                    ],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.04, -0.15],
                          [0, 0],
                          [-1.32, -0.33],
                          [0, 0],
                          [0, -0.15],
                          [0.15, -0.04],
                          [0, 0],
                          [0.33, -1.32],
                          [0, 0],
                          [0.15, 0],
                          [0.04, 0.15],
                          [0, 0],
                          [1.32, 0.33],
                          [0, 0],
                          [0, 0.15],
                          [-0.15, 0.04],
                          [0, 0],
                          [-0.33, 1.32],
                          [0, 0],
                          [-0.15, 0],
                        ],
                        o: [
                          [0.15, 0],
                          [0, 0],
                          [0.33, 1.32],
                          [0, 0],
                          [0.15, 0.04],
                          [0, 0.15],
                          [0, 0],
                          [-1.32, 0.33],
                          [0, 0],
                          [-0.04, 0.15],
                          [-0.15, 0],
                          [0, 0],
                          [-0.33, -1.32],
                          [0, 0],
                          [-0.15, -0.04],
                          [0, -0.15],
                          [0, 0],
                          [1.32, -0.33],
                          [0, 0],
                          [0.04, -0.15],
                          [0, 0],
                        ],
                        v: [
                          [3.69, 0],
                          [4.02, 0.25],
                          [4.1, 0.59],
                          [6.79, 3.28],
                          [7.13, 3.37],
                          [7.38, 3.69],
                          [7.13, 4.02],
                          [6.79, 4.1],
                          [4.1, 6.79],
                          [4.02, 7.13],
                          [3.69, 7.38],
                          [3.37, 7.13],
                          [3.28, 6.79],
                          [0.59, 4.1],
                          [0.25, 4.02],
                          [0, 3.69],
                          [0.25, 3.37],
                          [0.59, 3.28],
                          [3.28, 0.59],
                          [3.37, 0.25],
                          [3.69, 0],
                        ],
                      },
                    ],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.09, -0.37],
                          [0, 0],
                          [-3.26, -0.81],
                          [0, 0],
                          [0, -0.38],
                          [0.37, -0.09],
                          [0, 0],
                          [0.81, -3.26],
                          [0, 0],
                          [0.38, 0],
                          [0.09, 0.37],
                          [0, 0],
                          [3.26, 0.81],
                          [0, 0],
                          [0, 0.38],
                          [-0.37, 0.09],
                          [0, 0],
                          [-0.81, 3.26],
                          [0, 0],
                          [-0.38, 0],
                        ],
                        o: [
                          [0.38, 0],
                          [0, 0],
                          [0.81, 3.26],
                          [0, 0],
                          [0.37, 0.09],
                          [0, 0.38],
                          [0, 0],
                          [-3.26, 0.81],
                          [0, 0],
                          [-0.09, 0.37],
                          [-0.38, 0],
                          [0, 0],
                          [-0.81, -3.26],
                          [0, 0],
                          [-0.37, -0.09],
                          [0, -0.38],
                          [0, 0],
                          [3.26, -0.81],
                          [0, 0],
                          [0.09, -0.37],
                          [0, 0],
                        ],
                        v: [
                          [9.09, 0],
                          [9.89, 0.63],
                          [10.1, 1.46],
                          [16.71, 8.08],
                          [17.55, 8.29],
                          [18.18, 9.09],
                          [17.55, 9.89],
                          [16.71, 10.1],
                          [10.1, 16.71],
                          [9.89, 17.55],
                          [9.09, 18.18],
                          [8.29, 17.55],
                          [8.08, 16.71],
                          [1.46, 10.1],
                          [0.63, 9.89],
                          [0, 9.09],
                          [0.63, 8.29],
                          [1.46, 8.08],
                          [8.08, 1.46],
                          [8.29, 0.63],
                          [9.09, 0],
                        ],
                      },
                    ],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.09, -0.37],
                          [0, 0],
                          [-3.26, -0.81],
                          [0, 0],
                          [0, -0.38],
                          [0.37, -0.09],
                          [0, 0],
                          [0.81, -3.26],
                          [0, 0],
                          [0.38, 0],
                          [0.09, 0.37],
                          [0, 0],
                          [3.26, 0.81],
                          [0, 0],
                          [0, 0.38],
                          [-0.37, 0.09],
                          [0, 0],
                          [-0.81, 3.26],
                          [0, 0],
                          [-0.38, 0],
                        ],
                        o: [
                          [0.38, 0],
                          [0, 0],
                          [0.81, 3.26],
                          [0, 0],
                          [0.37, 0.09],
                          [0, 0.38],
                          [0, 0],
                          [-3.26, 0.81],
                          [0, 0],
                          [-0.09, 0.37],
                          [-0.38, 0],
                          [0, 0],
                          [-0.81, -3.26],
                          [0, 0],
                          [-0.37, -0.09],
                          [0, -0.38],
                          [0, 0],
                          [3.26, -0.81],
                          [0, 0],
                          [0.09, -0.37],
                          [0, 0],
                        ],
                        v: [
                          [9.09, 0],
                          [9.89, 0.63],
                          [10.1, 1.46],
                          [16.71, 8.08],
                          [17.55, 8.29],
                          [18.18, 9.09],
                          [17.55, 9.89],
                          [16.71, 10.1],
                          [10.1, 16.71],
                          [9.89, 17.55],
                          [9.09, 18.18],
                          [8.29, 17.55],
                          [8.08, 16.71],
                          [1.46, 10.1],
                          [0.63, 9.89],
                          [0, 9.09],
                          [0.63, 8.29],
                          [1.46, 8.08],
                          [8.08, 1.46],
                          [8.29, 0.63],
                          [9.09, 0],
                        ],
                      },
                    ],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.04, -0.15],
                          [0, 0],
                          [-1.32, -0.33],
                          [0, 0],
                          [0, -0.15],
                          [0.15, -0.04],
                          [0, 0],
                          [0.33, -1.32],
                          [0, 0],
                          [0.15, 0],
                          [0.04, 0.15],
                          [0, 0],
                          [1.32, 0.33],
                          [0, 0],
                          [0, 0.15],
                          [-0.15, 0.04],
                          [0, 0],
                          [-0.33, 1.32],
                          [0, 0],
                          [-0.15, 0],
                        ],
                        o: [
                          [0.15, 0],
                          [0, 0],
                          [0.33, 1.32],
                          [0, 0],
                          [0.15, 0.04],
                          [0, 0.15],
                          [0, 0],
                          [-1.32, 0.33],
                          [0, 0],
                          [-0.04, 0.15],
                          [-0.15, 0],
                          [0, 0],
                          [-0.33, -1.32],
                          [0, 0],
                          [-0.15, -0.04],
                          [0, -0.15],
                          [0, 0],
                          [1.32, -0.33],
                          [0, 0],
                          [0.04, -0.15],
                          [0, 0],
                        ],
                        v: [
                          [3.69, 0],
                          [4.02, 0.25],
                          [4.1, 0.59],
                          [6.79, 3.28],
                          [7.13, 3.37],
                          [7.38, 3.69],
                          [7.13, 4.02],
                          [6.79, 4.1],
                          [4.1, 6.79],
                          [4.02, 7.13],
                          [3.69, 7.38],
                          [3.37, 7.13],
                          [3.28, 6.79],
                          [0.59, 4.1],
                          [0.25, 4.02],
                          [0, 3.69],
                          [0.25, 3.37],
                          [0.59, 3.28],
                          [3.28, 0.59],
                          [3.37, 0.25],
                          [3.69, 0],
                        ],
                      },
                    ],
                    t: 144,
                  },
                  {
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.04, -0.15],
                          [0, 0],
                          [-1.32, -0.33],
                          [0, 0],
                          [0, -0.15],
                          [0.15, -0.04],
                          [0, 0],
                          [0.33, -1.32],
                          [0, 0],
                          [0.15, 0],
                          [0.04, 0.15],
                          [0, 0],
                          [1.32, 0.33],
                          [0, 0],
                          [0, 0.15],
                          [-0.15, 0.04],
                          [0, 0],
                          [-0.33, 1.32],
                          [0, 0],
                          [-0.15, 0],
                        ],
                        o: [
                          [0.15, 0],
                          [0, 0],
                          [0.33, 1.32],
                          [0, 0],
                          [0.15, 0.04],
                          [0, 0.15],
                          [0, 0],
                          [-1.32, 0.33],
                          [0, 0],
                          [-0.04, 0.15],
                          [-0.15, 0],
                          [0, 0],
                          [-0.33, -1.32],
                          [0, 0],
                          [-0.15, -0.04],
                          [0, -0.15],
                          [0, 0],
                          [1.32, -0.33],
                          [0, 0],
                          [0.04, -0.15],
                          [0, 0],
                        ],
                        v: [
                          [3.69, 0],
                          [4.02, 0.25],
                          [4.1, 0.59],
                          [6.79, 3.28],
                          [7.13, 3.37],
                          [7.38, 3.69],
                          [7.13, 4.02],
                          [6.79, 4.1],
                          [4.1, 6.79],
                          [4.02, 7.13],
                          [3.69, 7.38],
                          [3.37, 7.13],
                          [3.28, 6.79],
                          [0.59, 4.1],
                          [0.25, 4.02],
                          [0, 3.69],
                          [0.25, 3.37],
                          [0.59, 3.28],
                          [3.28, 0.59],
                          [3.37, 0.25],
                          [3.69, 0],
                        ],
                      },
                    ],
                    t: 198,
                  },
                ],
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 144,
                  },
                  { s: [0.0549, 0.3686, 1], t: 198 },
                ],
              },
              r: 1,
              o: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [100],
                    t: 144,
                  },
                  { s: [100], t: 198 },
                ],
              },
            },
          ],
          ind: 1,
        },
        {
          ty: 4,
          nm: 'Vector',
          sr: 1,
          st: 0,
          op: 145,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [9.09, 9.09],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [9.09, 9.09],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [3.69, 3.69],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [3.69, 3.69],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [9.09, 9.09],
                  t: 144,
                },
                { s: [9.09, 9.09], t: 198 },
              ],
            },
            s: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [100, 100],
                  t: 144,
                },
                { s: [100, 100], t: 198 },
              ],
            },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [9.03, 10.84],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [9.03, 10.84],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [3.69, 16],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [3.69, 16],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [9.03, 10.84],
                  t: 144,
                },
                { s: [9.03, 10.84], t: 198 },
              ],
            },
            r: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [0],
                  t: 144,
                },
                { s: [0], t: 198 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [100],
                  t: 144,
                },
                { s: [100], t: 198 },
              ],
            },
          },
          ef: [],
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.09, -0.37],
                          [0, 0],
                          [-3.26, -0.81],
                          [0, 0],
                          [0, -0.38],
                          [0.37, -0.09],
                          [0, 0],
                          [0.81, -3.26],
                          [0, 0],
                          [0.38, 0],
                          [0.09, 0.37],
                          [0, 0],
                          [3.26, 0.81],
                          [0, 0],
                          [0, 0.38],
                          [-0.37, 0.09],
                          [0, 0],
                          [-0.81, 3.26],
                          [0, 0],
                          [-0.38, 0],
                        ],
                        o: [
                          [0.38, 0],
                          [0, 0],
                          [0.81, 3.26],
                          [0, 0],
                          [0.37, 0.09],
                          [0, 0.38],
                          [0, 0],
                          [-3.26, 0.81],
                          [0, 0],
                          [-0.09, 0.37],
                          [-0.38, 0],
                          [0, 0],
                          [-0.81, -3.26],
                          [0, 0],
                          [-0.37, -0.09],
                          [0, -0.38],
                          [0, 0],
                          [3.26, -0.81],
                          [0, 0],
                          [0.09, -0.37],
                          [0, 0],
                        ],
                        v: [
                          [9.09, 0],
                          [9.89, 0.63],
                          [10.1, 1.46],
                          [16.71, 8.08],
                          [17.55, 8.29],
                          [18.18, 9.09],
                          [17.55, 9.89],
                          [16.71, 10.1],
                          [10.1, 16.71],
                          [9.89, 17.55],
                          [9.09, 18.18],
                          [8.29, 17.55],
                          [8.08, 16.71],
                          [1.46, 10.1],
                          [0.63, 9.89],
                          [0, 9.09],
                          [0.63, 8.29],
                          [1.46, 8.08],
                          [8.08, 1.46],
                          [8.29, 0.63],
                          [9.09, 0],
                        ],
                      },
                    ],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.09, -0.37],
                          [0, 0],
                          [-3.26, -0.81],
                          [0, 0],
                          [0, -0.38],
                          [0.37, -0.09],
                          [0, 0],
                          [0.81, -3.26],
                          [0, 0],
                          [0.38, 0],
                          [0.09, 0.37],
                          [0, 0],
                          [3.26, 0.81],
                          [0, 0],
                          [0, 0.38],
                          [-0.37, 0.09],
                          [0, 0],
                          [-0.81, 3.26],
                          [0, 0],
                          [-0.38, 0],
                        ],
                        o: [
                          [0.38, 0],
                          [0, 0],
                          [0.81, 3.26],
                          [0, 0],
                          [0.37, 0.09],
                          [0, 0.38],
                          [0, 0],
                          [-3.26, 0.81],
                          [0, 0],
                          [-0.09, 0.37],
                          [-0.38, 0],
                          [0, 0],
                          [-0.81, -3.26],
                          [0, 0],
                          [-0.37, -0.09],
                          [0, -0.38],
                          [0, 0],
                          [3.26, -0.81],
                          [0, 0],
                          [0.09, -0.37],
                          [0, 0],
                        ],
                        v: [
                          [9.09, 0],
                          [9.89, 0.63],
                          [10.1, 1.46],
                          [16.71, 8.08],
                          [17.55, 8.29],
                          [18.18, 9.09],
                          [17.55, 9.89],
                          [16.71, 10.1],
                          [10.1, 16.71],
                          [9.89, 17.55],
                          [9.09, 18.18],
                          [8.29, 17.55],
                          [8.08, 16.71],
                          [1.46, 10.1],
                          [0.63, 9.89],
                          [0, 9.09],
                          [0.63, 8.29],
                          [1.46, 8.08],
                          [8.08, 1.46],
                          [8.29, 0.63],
                          [9.09, 0],
                        ],
                      },
                    ],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.04, -0.15],
                          [0, 0],
                          [-1.32, -0.33],
                          [0, 0],
                          [0, -0.15],
                          [0.15, -0.04],
                          [0, 0],
                          [0.33, -1.32],
                          [0, 0],
                          [0.15, 0],
                          [0.04, 0.15],
                          [0, 0],
                          [1.32, 0.33],
                          [0, 0],
                          [0, 0.15],
                          [-0.15, 0.04],
                          [0, 0],
                          [-0.33, 1.32],
                          [0, 0],
                          [-0.15, 0],
                        ],
                        o: [
                          [0.15, 0],
                          [0, 0],
                          [0.33, 1.32],
                          [0, 0],
                          [0.15, 0.04],
                          [0, 0.15],
                          [0, 0],
                          [-1.32, 0.33],
                          [0, 0],
                          [-0.04, 0.15],
                          [-0.15, 0],
                          [0, 0],
                          [-0.33, -1.32],
                          [0, 0],
                          [-0.15, -0.04],
                          [0, -0.15],
                          [0, 0],
                          [1.32, -0.33],
                          [0, 0],
                          [0.04, -0.15],
                          [0, 0],
                        ],
                        v: [
                          [3.69, 0],
                          [4.02, 0.25],
                          [4.1, 0.59],
                          [6.79, 3.28],
                          [7.13, 3.37],
                          [7.38, 3.69],
                          [7.13, 4.02],
                          [6.79, 4.1],
                          [4.1, 6.79],
                          [4.02, 7.13],
                          [3.69, 7.38],
                          [3.37, 7.13],
                          [3.28, 6.79],
                          [0.59, 4.1],
                          [0.25, 4.02],
                          [0, 3.69],
                          [0.25, 3.37],
                          [0.59, 3.28],
                          [3.28, 0.59],
                          [3.37, 0.25],
                          [3.69, 0],
                        ],
                      },
                    ],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.04, -0.15],
                          [0, 0],
                          [-1.32, -0.33],
                          [0, 0],
                          [0, -0.15],
                          [0.15, -0.04],
                          [0, 0],
                          [0.33, -1.32],
                          [0, 0],
                          [0.15, 0],
                          [0.04, 0.15],
                          [0, 0],
                          [1.32, 0.33],
                          [0, 0],
                          [0, 0.15],
                          [-0.15, 0.04],
                          [0, 0],
                          [-0.33, 1.32],
                          [0, 0],
                          [-0.15, 0],
                        ],
                        o: [
                          [0.15, 0],
                          [0, 0],
                          [0.33, 1.32],
                          [0, 0],
                          [0.15, 0.04],
                          [0, 0.15],
                          [0, 0],
                          [-1.32, 0.33],
                          [0, 0],
                          [-0.04, 0.15],
                          [-0.15, 0],
                          [0, 0],
                          [-0.33, -1.32],
                          [0, 0],
                          [-0.15, -0.04],
                          [0, -0.15],
                          [0, 0],
                          [1.32, -0.33],
                          [0, 0],
                          [0.04, -0.15],
                          [0, 0],
                        ],
                        v: [
                          [3.69, 0],
                          [4.02, 0.25],
                          [4.1, 0.59],
                          [6.79, 3.28],
                          [7.13, 3.37],
                          [7.38, 3.69],
                          [7.13, 4.02],
                          [6.79, 4.1],
                          [4.1, 6.79],
                          [4.02, 7.13],
                          [3.69, 7.38],
                          [3.37, 7.13],
                          [3.28, 6.79],
                          [0.59, 4.1],
                          [0.25, 4.02],
                          [0, 3.69],
                          [0.25, 3.37],
                          [0.59, 3.28],
                          [3.28, 0.59],
                          [3.37, 0.25],
                          [3.69, 0],
                        ],
                      },
                    ],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.09, -0.37],
                          [0, 0],
                          [-3.26, -0.81],
                          [0, 0],
                          [0, -0.38],
                          [0.37, -0.09],
                          [0, 0],
                          [0.81, -3.26],
                          [0, 0],
                          [0.38, 0],
                          [0.09, 0.37],
                          [0, 0],
                          [3.26, 0.81],
                          [0, 0],
                          [0, 0.38],
                          [-0.37, 0.09],
                          [0, 0],
                          [-0.81, 3.26],
                          [0, 0],
                          [-0.38, 0],
                        ],
                        o: [
                          [0.38, 0],
                          [0, 0],
                          [0.81, 3.26],
                          [0, 0],
                          [0.37, 0.09],
                          [0, 0.38],
                          [0, 0],
                          [-3.26, 0.81],
                          [0, 0],
                          [-0.09, 0.37],
                          [-0.38, 0],
                          [0, 0],
                          [-0.81, -3.26],
                          [0, 0],
                          [-0.37, -0.09],
                          [0, -0.38],
                          [0, 0],
                          [3.26, -0.81],
                          [0, 0],
                          [0.09, -0.37],
                          [0, 0],
                        ],
                        v: [
                          [9.09, 0],
                          [9.89, 0.63],
                          [10.1, 1.46],
                          [16.71, 8.08],
                          [17.55, 8.29],
                          [18.18, 9.09],
                          [17.55, 9.89],
                          [16.71, 10.1],
                          [10.1, 16.71],
                          [9.89, 17.55],
                          [9.09, 18.18],
                          [8.29, 17.55],
                          [8.08, 16.71],
                          [1.46, 10.1],
                          [0.63, 9.89],
                          [0, 9.09],
                          [0.63, 8.29],
                          [1.46, 8.08],
                          [8.08, 1.46],
                          [8.29, 0.63],
                          [9.09, 0],
                        ],
                      },
                    ],
                    t: 144,
                  },
                  {
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [-0.09, -0.37],
                          [0, 0],
                          [-3.26, -0.81],
                          [0, 0],
                          [0, -0.38],
                          [0.37, -0.09],
                          [0, 0],
                          [0.81, -3.26],
                          [0, 0],
                          [0.38, 0],
                          [0.09, 0.37],
                          [0, 0],
                          [3.26, 0.81],
                          [0, 0],
                          [0, 0.38],
                          [-0.37, 0.09],
                          [0, 0],
                          [-0.81, 3.26],
                          [0, 0],
                          [-0.38, 0],
                        ],
                        o: [
                          [0.38, 0],
                          [0, 0],
                          [0.81, 3.26],
                          [0, 0],
                          [0.37, 0.09],
                          [0, 0.38],
                          [0, 0],
                          [-3.26, 0.81],
                          [0, 0],
                          [-0.09, 0.37],
                          [-0.38, 0],
                          [0, 0],
                          [-0.81, -3.26],
                          [0, 0],
                          [-0.37, -0.09],
                          [0, -0.38],
                          [0, 0],
                          [3.26, -0.81],
                          [0, 0],
                          [0.09, -0.37],
                          [0, 0],
                        ],
                        v: [
                          [9.09, 0],
                          [9.89, 0.63],
                          [10.1, 1.46],
                          [16.71, 8.08],
                          [17.55, 8.29],
                          [18.18, 9.09],
                          [17.55, 9.89],
                          [16.71, 10.1],
                          [10.1, 16.71],
                          [9.89, 17.55],
                          [9.09, 18.18],
                          [8.29, 17.55],
                          [8.08, 16.71],
                          [1.46, 10.1],
                          [0.63, 9.89],
                          [0, 9.09],
                          [0.63, 8.29],
                          [1.46, 8.08],
                          [8.08, 1.46],
                          [8.29, 0.63],
                          [9.09, 0],
                        ],
                      },
                    ],
                    t: 198,
                  },
                ],
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [0.0549, 0.3686, 1],
                    t: 144,
                  },
                  { s: [0.0549, 0.3686, 1], t: 198 },
                ],
              },
              r: 1,
              o: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [100],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [100],
                    t: 144,
                  },
                  { s: [100], t: 198 },
                ],
              },
            },
          ],
          ind: 2,
        },
        {
          ty: 4,
          nm: 'AI Loader - solid blue✅ Bg',
          sr: 1,
          st: 0,
          op: 145,
          ip: 0,
          hd: false,
          ddd: 0,
          bm: 0,
          hasMask: false,
          ao: 0,
          ks: {
            a: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [10, 10],
                  t: 144,
                },
                { s: [10, 10], t: 198 },
              ],
            },
            s: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100, 100],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [100, 100],
                  t: 144,
                },
                { s: [100, 100], t: 198 },
              ],
            },
            sk: { a: 0, k: 0 },
            p: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [10, 10],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [10, 10],
                  t: 144,
                },
                { s: [10, 10], t: 198 },
              ],
            },
            r: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [0],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [0],
                  t: 144,
                },
                { s: [0], t: 198 },
              ],
            },
            sa: { a: 0, k: 0 },
            o: {
              a: 1,
              k: [
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 0,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 54,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 72,
                },
                {
                  o: { x: 0.33, y: 1 },
                  i: { x: 0.68, y: 1 },
                  s: [100],
                  t: 126,
                },
                {
                  o: { x: 0, y: 0 },
                  i: { x: 1, y: 1 },
                  s: [100],
                  t: 144,
                },
                { s: [100], t: 198 },
              ],
            },
          },
          ef: [],
          shapes: [
            {
              ty: 'sh',
              bm: 0,
              hd: false,
              nm: '',
              d: 1,
              ks: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [20, 0],
                          [20, 20],
                          [0, 20],
                          [0, 0],
                        ],
                      },
                    ],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [20, 0],
                          [20, 20],
                          [0, 20],
                          [0, 0],
                        ],
                      },
                    ],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [20, 0],
                          [20, 20],
                          [0, 20],
                          [0, 0],
                        ],
                      },
                    ],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [20, 0],
                          [20, 20],
                          [0, 20],
                          [0, 0],
                        ],
                      },
                    ],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [20, 0],
                          [20, 20],
                          [0, 20],
                          [0, 0],
                        ],
                      },
                    ],
                    t: 144,
                  },
                  {
                    s: [
                      {
                        c: true,
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [20, 0],
                          [20, 20],
                          [0, 20],
                          [0, 0],
                        ],
                      },
                    ],
                    t: 198,
                  },
                ],
              },
            },
            {
              ty: 'fl',
              bm: 0,
              hd: false,
              nm: '',
              c: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [1, 1, 1],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [1, 1, 1],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [1, 1, 1],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [1, 1, 1],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [1, 1, 1],
                    t: 144,
                  },
                  { s: [1, 1, 1], t: 198 },
                ],
              },
              r: 1,
              o: {
                a: 1,
                k: [
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0],
                    t: 0,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0],
                    t: 54,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0],
                    t: 72,
                  },
                  {
                    o: { x: 0.33, y: 1 },
                    i: { x: 0.68, y: 1 },
                    s: [0],
                    t: 126,
                  },
                  {
                    o: { x: 0, y: 0 },
                    i: { x: 1, y: 1 },
                    s: [0],
                    t: 144,
                  },
                  { s: [0], t: 198 },
                ],
              },
            },
          ],
          ind: 3,
        },
      ],
    },
  ],
};
